
    /**
     * Подключаем модули
     */
    require('./components/extra');
    require('./components/select2');
    require('../revered/components/events');
    require('../revered/components/iframes');
    require('../revered/components/file_upload');
    require('../common/components/sweetalert');
    require('./components/page_loading');
    window.bootstrap = require('../libs/bootstrap.bundle');


    /**
     * Каждые 5 секунд получаем информацию с backend для GUEST
     */
    setInterval(function (){

        //Параметры, которые передаем на сервер
        let request_data = {

        };


        //Выполняем запрос
        request('GET', '/' + window.current_region + '/guest/refresh-data', request_data, function (response) {

            //Обновляем CSRF token
            if( response.csrf_token )
                setCSRF(response.csrf_token);



        //Что-то пошло не так
        }, function (error, code) {

            console.error(code + " : " + error);

        });

    },5000);


    eventClick('[data-redirect-href]', function (elem, event){

        window.location.href = elem.attr('data-redirect-href');

    });


    /**
     * Установить поле поиска города
     */
    setUpCitySelectField();

    /**
     * Смена локализации
     */
    eventClick('.site-local-select',  (data) => window.location= `/set-localization/${data.data('locale')}`)

    /**
     * Смена региона
     */
    eventClick('.region-key-select',  (data) => window.location= `/set-region/${data.data('region')}`)

    eventClick('.header .burger', function() {
        document.body.classList.toggle('mobile-menu-open')
    })

    /**
     * Пометить уведомления как прочитанный
     */
    eventClick('.view-notifications', function (){
        const ids = [];
        $('.make-read-notifications').each(function (key, item) {
            if ($(item).hasClass('active')){
                ids.push($(item).data('id'));
            }
        });

        if (ids.length){
            setTimeout( () => request('POST', route('user.make-notifications-read'), {ids}, function () {

                $('.make-read-notifications').each(function (key, item) {
                    if ($(item).hasClass('active')){
                        $(item).removeClass('active')
                    }
                });

                $('.view-notifications').removeClass('active');

            }), 1500)
        }

    })


    /**
     * Инициализация Tooltips
     */
    window.initTooltips = function(){
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
    }
    initTooltips();
